import React, { useCallback, useEffect, useState } from "react";
import Button from "@mui/material/Button";
// import completedImage from "../../assests/images/Completed.png";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
// import LayersIcon from "@mui/icons-material/Layers";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import purchaseImage from "../../assests/images/Purchase.png";
// import pendingImage from "../../assests/images/Pending.png";
// import shippedImage from "../../assests/images/Shipped.png";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import { Link, useLocation } from "react-router-dom";
// import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
// import holdImage from "../../assests/images/hold.png";
// import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
// import recallmage from "../../assests/images/recall.png";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import Stepper from "@mui/material/Stepper";
// import Step from "@mui/material/Step";
// import StepLabel from "@mui/material/StepLabel";
// import StepContent from "@mui/material/StepContent";
// import List from "@mui/material/List";
// import Divider from "@mui/material/Divider";
// import Drawer from "@mui/material/Drawer";
// import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
// import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
// import Accordion from "@mui/material/Accordion";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { purchaseOrderServices } from "../../services/purchaseOrderServices";
// import TableListing from "../common/tableListing";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import { DatePicker, Space } from 'antd';
import _ from "lodash";
import { convertToYYMMDD, isEmptyDash, returnRateVal, returnZero, strToDate, totalInr, trimString } from "../../constant";
import { Backdrop, CircularProgress, Tooltip } from "@mui/material";
// import Filter from "../filter/filter";
import { downloadFile } from "../buyerPurchaseOrder";
import AlertComponent from "../alert/alert";
import { rfqServices } from "../../services/rfqServices";
import CustomSearchDropdown from "../common/customSearchDropdown";
import checkImage from "../../assests/images/check-circle.png";
import dayjs from "dayjs";


const initialColumns = [
  { id: "purchasing_document", label: "Purchasing Document", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "assignment", label: "Assignment", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "document", label: "Document", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "credit_control_area", label: "Credit Control Area", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "profit_center", label: "Profit Center", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "document_date", label: "Document Date", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "amt", label: "Amount (Amt)", isSort: true, sortLabel: "", formate: "RATE" },
  { id: "business_area", label: "Business Area", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "dates", label: "Dates", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "spl_GL", label: "Special GL (Spl_GL)", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "tax_code", label: "Tax Code", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "fiscal_year", label: "Fiscal Year", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "cost_center", label: "Cost Center", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "vendor", label: "Vendor", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "invoice_reference", label: "Invoice Reference", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "clearing_doc", label: "Clearing Document", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "currency", label: "Currency", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "text", label: "Text", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "posting_date", label: "Posting Date", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "gl_account", label: "GL Amount", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "document_type", label: "Documnet Type", isSort: true, sortLabel: "", formate: "TEXT" },
];

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const steps = [
  {
    label: "PO Creation",
    text: "Created on : 12-02-2024",
    description: `Created At : 10:00`,
    remarks: `Created By : Sanjeev`,
  },
  {
    label: "PO Approval",
    text: "Approved on : 12-02-2024",
    description: `Approved By : Sanjeev`,
  },
  {
    label: "QC Creation : QC0001, QC0002",
    headings: "QC0001",
    text: "Approved on : 12-02-2024",
    remarks: "QC Created At : 10:00",
    description: `Approved By : Sanjeev`,
    headings2: "QC0002",
    remarks2: "QC Created on : 12-02-2024",
    description2: "QC Created At : 10:00",
    text2: "QC Created By : Sanjeev"
  },
  {
    label: "LR Creation : LR0001, LR0002",
    headings: "LR0001",
    text: "LR Created on : 12-02-2024",
    remarks: "LR Created At : 10:00",
    description: `LR Created By : Sanjeev`,
    headings2: "LR0002",
    remarks2: "LR Created on : 12-02-2024",
    description2: "LR Created At : 10:00",
    text2: "LR Created By : Sanjeev"
  },
  {
    label: "QC Creation : QC0003, QC0004",
    headings: "QC0003",
    text: "QC Created on : 12-02-2024",
    remarks: "QC Created At : 10:00",
    description: `QC Created By : Sanjeev`,
    headings2: "QC0004",
    remarks2: "QC Created on : 12-02-2024",
    description2: "QC Created At : 10:00",
    text2: "QC Created By : Sanjeev"
  },
  {
    label: "LR Delivered : LR0001, LR0002",
    headings: "LR0001",
    text: "LR Created on : 12-02-2024",
    remarks: "LR Created At : 10:00",
    description: `LR Created By : Sanjeev`,
    headings2: "LR0004",
    remarks2: "LR Created on : 12-02-2024",
    description2: "LR Created At : 10:00",
    text2: "LR Created By : Sanjeev"
  },
  {
    label: "Gate Creation : GE0001, GE0002",
    headings: "GE0001",
    text: "GE Created on : 12-02-2024",
    remarks: "GE Created At : 10:00",
    description: `GE Created By : Sanjeev`,
    headings2: "GE0002",
    remarks2: "GE Created on : 12-02-2024",
    description2: "GE Created At : 10:00",
    text2: "GE Created By : Sanjeev"
  },
  {
    label: "GRN Creation : GRN0001, GRN0002",
    headings: "GRN0001",
    text: "GRN Created on : 12-02-2024",
    remarks: "GRN Created At : 10:00",
    description: `GRN Created By : Sanjeev`,
    headings2: "GRN0002",
    remarks2: "GRN Created on : 12-02-2024",
    description2: "GRN Created At : 10:00",
    text2: "GRN Created By : Sanjeev"
  },

  // Add more steps if needed...
];
function ListingAccount() {
  const qcListing = {
    currentPage: 1,
    totalPages: 20,
  }
  
    const requestPayloadInitials = {
      pageNumber: 1,
      pageSize: 10,
      sortArray: [],
      searchCriteria: [],
    };
    const emptyData = {
      totalPages: 0,
      currentPage: 1,
      totalItems: 0,
      ledgers: [],
    };
    const [alertComponent, setAlertComponent] = useState({
      open: false,
      message: "",
      type: "",
    });
    const [isLoading, setIsLoading] = useState(false);
    const [polisting, setPOListing] = React.useState(emptyData);

  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [filterText, setFilterText] = useState("");
  const [selectedPOArr, setSelectedPOArr] = useState([]);
  const [filterFormData, setFilterFormData] = useState("");
  const [trackOrderData, setTrackOrderData] = useState("");

  const [inputPage, setInputPage] = useState(qcListing?.currentPage || 1);
  const [openpopdfpurchasemodal, setOpenPoPdfPurchaseModal] = useState(false);
  const [newRfqValidity, setNewRfqValidity] = useState({ from: "", to: "" });
  const [downloadEl, setdownloadEl] = React.useState(null);
  const [newValidityPeriod, setNewValidityPeriod] = useState(["",""]);
  const [dates, setDates] = useState([null, null]);
  
    const [openheaderlevelexcelmodal, setOpenHeaderLevelExcelModal] =
      useState(false);
    const [confirmObj, setConfirmObj] = useState({});
    const [openheaderlevelsucessfullymodal, setOpenHeaderLevelSucessfullyModal] =
      useState(false);

  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };
  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  useEffect(() => {
    if (!isEmptyDash(selectedObjCode?.selectedValue)) {
      getListing(requestPayload, filterText, selectedObjCode?.selectedValue, newValidityPeriod);      
    }
  }, [requestPayload]);
  
  
    // useEffect(() => {
    //   let secPOPermissionInit = _.cloneDeep(secPOPermission);
    //   let obj = {};
    //   for (let key in secPOPermissionInit) {
    //     obj[key] = getSecPermission(key);
    //   }
    //   setSecPOPermission(obj);
  
    // }, []);
  
    const getListing = (requestPayloadParam, filterTextParam, vendorId, dateRange) => {
      if (isEmptyDash(dateRange[0]) || isEmptyDash(dateRange[1])) {
        setAlertComponent({ open: true, type: "error", message: `Please select valid date range.` });          
      }
      setIsLoading(true);
      let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}&vendorId=${vendorId}&startDate=${convertToYYMMDD(dateRange[0])}&endDate=${convertToYYMMDD(dateRange[1])}`;
      // let param = `?vendorId=66ed5c333e5e60c0217ed728&startDate=2024-06-01&endDate=2024-09-01`;
      if (requestPayloadParam.sortArray.length > 0) {
        param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
      }
      // const filteredFormData = formData ? Object.entries(formData)
      //   .filter(([key, value]) => value !== '')
      //   .reduce((acc, [key, value]) => {
      //     acc[key] = value;
      //     return acc;
      //   }, {}) : {};
      // if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      //   Object.entries(filteredFormData).forEach(([key, value]) => {
      //     param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      //   });
      // }
  
      let promise = purchaseOrderServices.getAccountLedgerListing(param);
      promise.then((res) => {
        if (res.data.success === true) {
          setPOListing(res?.data?.data);
        } else {
          setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
        }
      })
        .catch(function (error) {
          setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
        })
        .finally((param) => {
          setIsLoading(false);
        });
    };
    
    const onFilterTextChange = (e) => {
      let { value } = e.target;
      setFilterText(value);
      debouncedSearch(value);
    };
  
    const onKeyPressHandler = (e) => {
      e.persist();
      if (e.key === "Enter") {
        onFilterSubmit();
      }
    };
    const onFilterSubmit = () => {
      getListing(requestPayload, filterText, selectedObjCode?.selectedValue, newValidityPeriod);
    };
  
    const debouncedSearch = useCallback(
      _.debounce((searchTerm) => {
        let requestPayloadInit = _.cloneDeep(requestPayload);
        requestPayloadInit.pageNumber = 1;
        setRequestPayload(requestPayloadInit);
  
      }, 800),
      []
    );
  
    const onSortChange = (index, sortBy, sortOrder) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      let columnsInit = _.cloneDeep(columns);
      let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
      requestPayloadInit.sortArray = [sortBy, newSortLael];
      requestPayloadInit.pageNumber = 1;
  
      for (let i = 0; i < columnsInit.length; i++) {
        columnsInit[i].sortLabel = "";
        if (i == index) {
          columnsInit[i].sortLabel = newSortLael;
        }
      }
  
      setRequestPayload(requestPayloadInit);
      setColumns(columnsInit);
    }
    const onPaginationChange = (e, value) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = value;
      setRequestPayload(requestPayloadInit);
    }
  
    const onPageSizeChange = (e) => {
      let { value } = e.target;
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageSize = value;
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
    }
      
    // const handleFilterFormSubmit = (formDataa) => {
    //   setFilterFormData(formDataa);
    //   const updatedPayload = {
    //     ...requestPayload,
    //     searchCriteria: formDataa,
    //   };
    //   setRequestPayload(updatedPayload);
    //   getListing(updatedPayload, filterText, formDataa || '');
    // };
  
    // const handleResetFormSubmit = () => {
    //   getListing(requestPayload, filterText, {});
    // }
    
    
      const openConfirmModal = (param) => {
        if (isEmptyDash(selectedObjCode?.selectedValue) || isEmptyDash(newValidityPeriod[0]) || isEmptyDash(newValidityPeriod[1])) {
          setAlertComponent({ open: true, type: "error", message: `Please select valid fields to download file. ` });
          return;
        }
        let obj = {};
        obj["id"] = param;
        if (param == "excel") {
          obj["text"] = " Excel";
        }
        if (param == "pdf") {
          obj["text"] = " PDF";
        }
        setConfirmObj(obj);
        setOpenHeaderLevelExcelModal(true);
      }
    
      const closeConfirmModal = (param) => {
        setConfirmObj({});
        setOpenHeaderLevelExcelModal(false);
      }
    
      const downloadPO = () => {
        setIsLoading(true);
        let bodyData = {
          "type": confirmObj?.id, // "line-item", header, pdf
          "vendorId": selectedObjCode?.selectedValue,
          // "datePreset": "oneMonth", //threeMonths, sixMonths, oneYear
          "dateRange": {
              "startDate": convertToYYMMDD(newValidityPeriod[0]),
              "endDate": convertToYYMMDD(newValidityPeriod[1])
          }
        };
        let fileName = "";
        
        if (confirmObj?.id == "excel") {
          fileName = "Ledger_Excel.xlsx";
        }
        if (confirmObj?.id == "pdf") {
          fileName = "Ledger_PDF.pdf";
        }
        const data = {
          url: `/v1/internal/account-ledgers/download`,
          bodyData: bodyData,
          method: "POST",
          fileName: fileName
        };
        downloadFile(data)
          .then(response => {
            setOpenHeaderLevelExcelModal(false);
            setOpenHeaderLevelSucessfullyModal(true);
          })
          .catch(error => {
            setAlertComponent({ open: true, type: "error", message: `There is some error to download file. ` });
          })
          .finally(() => {
            setIsLoading(false);
            setOpenHeaderLevelExcelModal(false);
          })
    
      }
  
    const onPOCheckChange = (value, row, rowIndex) => {
      let polistingInit = _.cloneDeep(polisting);
      polistingInit.ledgers[rowIndex].isChecked = value;
      let arr = [];
      for (let i = 0; i < polistingInit.ledgers.length; i++) {
        if (polistingInit.ledgers[i].isChecked == true) {
          arr.push(polistingInit.ledgers[i]._id);
        }
      }
      setSelectedPOArr(arr);
      setPOListing(polistingInit);
    }

    const [selectedObjCode, setSelectedObjCode] = useState(null);
    const onSearchSelectChange = (param) => {
      setSelectedObjCode(param);
    }

    const clearData = (param) => {
      setSelectedObjCode({selectedLable: "", selectedValue: ""}); 
      setFilterText("");  
      setNewValidityPeriod(["",""]);
      setDates([null,null])
      setPOListing(emptyData);
      // getListing(requestPayload, filterText, selectedObjCode?.selectedValue, newValidityPeriod);  
    }

    const applyFilter = (param) => {
      // setSelectedObj({selectedLable: "", selectedValue: ""}); 
      setFilterText("");  
      getListing(requestPayload, "", selectedObjCode?.selectedValue, newValidityPeriod);
    }

  const handleNewDatePickerChange = (dates, dateStrings) => {
    console.log(dates, dateStrings);
    setNewValidityPeriod(dateStrings);
    setDates(dates);
  };
  
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= qcListing?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(qcListing?.currentPage);
      }
    }
  };

  const [opencreateentry, setOpenCreateEntry] = useState(false);
  const [columns, setColumns] = useState(initialColumns);
  

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);

    setColumns(reorderedColumns);
  };
  
  return (
    <>
      <div className="login-forms">
        <div className="text-centers row_purchase_invoice_dragdropcontext_apps_body">
          <div>
            <div className="search_filter_outerse_vendorledger ms-auto">
              <div className="search_mains">
                <h5>Account Ledger Listing</h5>
              </div>
            </div>
           
           
            <div className="search_filter_outers ms-auto">
              <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"
                      
                      onChange={onFilterTextChange}
                      value={filterText}
                      onKeyPress={onKeyPressHandler}
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
        
            </div>
            <div className="Maine_box1_Section_spacepicker">
            <div className="maineSection_Row2ledger">
             <div className="modalbody_createasnpurchase1">
                <label style={{marginBottom:"10px"}}>Vendor Code </label>
                <CustomSearchDropdown 
                    // column={initialColumns}
                    listingArrName="vendors"
                    onSearchSelectChange={onSearchSelectChange}
                    promiseRequest={rfqServices.getExistingVendorRfqListing}
                    extraPromiseParam="poExists=true"
                    additionalData={{
                      lableKeyName1: "vendorName",
                      lableKeyName2: "",
                      valueKeyName: "_id",
                    }} 
                    // isDisable={(details?.assigneeId != UserObj?._id)}  
                    defaultValue={selectedObjCode}           
                  /> 
                
              </div>
                  <div>
                    <label style={{marginBottom:"10px"}}>Data Range</label>
                    <div className="Section_main_box_account">
                    <div className="Row_sectionMaine_picker">
                      <Space direction="vertical" size={20}>
                          <DatePicker.RangePicker 
                            className="datepicker_widthdashboard" 
                            getPopupContainer={trigger => trigger.parentNode} 
                            placement="bottomLeft" 
                            onChange={handleNewDatePickerChange} 
                            // disabledDate={disabledDate} 
                            format="DD-MM-YYYY" 
                            value={dates}
                          />

                      </Space>
                      <button type="button" class="btn btn-success save_next_btns" onClick={applyFilter}>
                    Apply
                  </button>
                  <button type="button" class="btn clear_btn_status_block_lists" style={{marginLeft: "10px"}} onClick={clearData}>
                    Clear
                  </button>
                    </div>
                    </div>
                  </div>
             </div>
             <div className="listingSectionspace_Picker">
                  <div>
                <Button
                  className="vendor_btn vendor_maine_contents"
                  id="basic-button"
                  aria-controls={download ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={download ? "true" : undefined}
                  onClick={handleClicks}
                >
                  <FileDownloadIcon />
                  Download
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={downloadEl}
                  open={download}
                  onClose={handleCloses}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
              <div className="">
              <MenuItem onClick={() => openConfirmModal("excel")}>
                  Account Excel
                </MenuItem>
                {/* <MenuItem onClick={() => openConfirmModal("line-item")}>
                  Line Item Level Excel
                </MenuItem> */}
                <MenuItem onClick={() => openConfirmModal("pdf")}>
                 Account PDF
                </MenuItem>
              </div>
                </Menu>
              </div>
                {/* <div>
                  
                  <div className="row_filterrbtnvendor_box">
                    <div className="lets_filter_vendorlist_body_detail">
                      <FilterAltOutlinedIcon />
                      <Filter uniqueName={"LEDGER"} formSubmitFunction={handleFilterFormSubmit} resetFilter={handleResetFormSubmit} />
                    </div>
                  </div>
                </div> */}
                  </div>
                  </div>
            <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable" direction="horizontal">
                          {(provided) => (
                            <div style={{ width: "100%", overflow: "hidden" }}
                         className="listing_main listing_main_dragdropcontext_body"
                              // style={{ height: "400px" }}
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                            >
                           <table className="dragdropcontext_ondragend_block_row">
                                <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                                  <tr>
                                    <th className="vendor_tabels">
                                      <input type="checkbox" />
                                    </th>
                                    {columns.map((column, index) => (
                                      <Draggable
                                        key={column.id}
                                        draggableId={column.id}
                                        index={index}
                                      >
                                        {(provided) => (
                                          <th
                                            className="vendor_tabels"
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                          >
                                            {column.label}
                                            {column.isSort && (
                                            <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                                            {/* <SwapVertIcon className="swap-sort-ico" /> */}
                                            {(column.sortLabel != "asc") && <img src={topArrow} />}
                                            {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                            {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                                            {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                          </span>
                                            )}
                                          </th>
                                        )}
                                      </Draggable>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody style={{ overflowY: "scroll", width: "200px" }}>
                                  {polisting?.ledgers.length < 1 && <>
                                        <tr>
                                          <td colSpan={10} className="text-center list-no-data">No Data Found</td>
                                        </tr>
                                      </>}
                                      {polisting?.ledgers?.map((row, rowIndex) => (
                                        <tr key={row.poNumber} className="maine_tr_vendor">
                                          <td>
                                            <input type="checkbox" checked={row.isChecked} onChange={(e) => onPOCheckChange(e.target.checked, row, rowIndex)} />
                                          </td>
                                          {columns.map((column, index) => (<>
                                            { (column.formate == "DATE") ? (<td>
                                              <p  >
                                                {isEmptyDash(row[column.id]) ? "N/A" : strToDate(row[column.id])}
                                              </p>
                                            </td>) : (column.formate == "QTY") ? (<td>
                                              <p  >
                                                {isEmptyDash(row[column.id]) ? "-" : row[column.id]}
                                              </p>
                                            </td>) :
                                              (column?.formate == "RATE") ?
                                              <td> 
                                                {returnRateVal(row[column?.id])}
                                                {/* ₹{totalInr(returnZero(row[column?.id]))}  */}
                                              </td> :
                                              <td key={index} >
                                                <Tooltip title={row[column.id] || "N/A"}>
                                                {trimString(row[column.id], 20 || "N/A")}
                                                </Tooltip>
                                              </td>
                                            }
                    
                                            {/* <td key={column.id}>{row[column.id]}</td> */}
                                          </>
                                          ))}
                                        </tr>
                                      ))}
                                </tbody>
                              </table>
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                     
          {polisting?.ledgers.length > 0 && <>
            <div className="lets_pagination_package_listing_react">
              <div className="pagination_select_react_packagelr_detail">
                <select
                  className="form-select packagelrlisting from-hs"
                  onChange={onPageSizeChange}
                  value={requestPayload?.pageSize}
                >
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span className="react_text_showing">
                  {` Showing rows ${Number(polisting?.pageSize) * Number(polisting?.currentPage - 1) + 1} to ${Number(polisting?.pageSize) * Number(polisting?.currentPage - 1) + Number(polisting?.ledgers.length)} of ${polisting?.totalItems}`}
                </span>
              </div>
              {/* <Stack spacing={2}>
                <Pagination
                  count={polisting?.totalPages}
                  page={polisting?.currentPage}
                  onChange={onPaginationChange}
                  renderItem={(item) => (<>
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  </>
                  )}
                />
              </Stack> */}

              <Stack spacing={2}>
                <Pagination
                  count={polisting?.totalPages}
                  page={polisting?.currentPage}
                  onChange={(event, page) => {
                    setInputPage(page);
                    onPaginationChange(event, page);
                  }}
                  renderItem={(item) => {
                    if (item.page === polisting?.currentPage) {
                      return (
                        <input
                          className="form-control"
                          type="text"
                          value={inputPage}
                          onChange={handleInputChange}
                          onKeyDown={handleInputSubmit}
                          style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                        />
                      );
                    }
                    return (
                      <PaginationItem
                        className="pagination_react_listings"
                        slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                      />
                    );
                  }}
                />
              </Stack>
            </div>
          </>}
            
            {/* <TableListing
                column={initialColumns}
                listingArrName="requests"
                filterKeyName={"PO_REQUEST_INTERNAL"}
                componentName="PO_MODIFICATION_LIST" 
                promiseRequest={purchaseOrderServices?.getPORequestListing}
                promiseUrlType="LIST"
                additionalData={{
                  isMaster: false,
                  type: "PO Modification Request",
                  isTrackOrder: false,
                  isFilter: true,
                  isSearch: true,
                  isPagePerSize: true,
                  isPagination: true,
                  isDragable: true,
                }}
            /> */}


          </div>
          
            <Modal
              open={openheaderlevelexcelmodal}
              onClose={closeConfirmModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHeaderLevelExcelModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p class="project_Manager_bidding">
                    Are you sure you want to download
                    <br /> {confirmObj?.text}
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={downloadPO}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={closeConfirmModal}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          {/* Header Level Sucessfully Purchase listing */}
            <Modal
              open={openheaderlevelsucessfullymodal}
              onClose={() => setOpenHeaderLevelSucessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHeaderLevelSucessfullyModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={checkImage} alt="" />
                  <p class="project_Manager_bidding">
                    Selected <b>{confirmObj?.text}</b> file has been
                    <br /> downloaded successfully.
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenHeaderLevelSucessfullyModal(false);
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>

        </div>
      </div>
      
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 99999999,//theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default ListingAccount;
